/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { sort } from '@ember/object/computed';
import ApiCredentialModel from 'cio/models/api-credential';

interface TrackingKeysTableComponentArgs {
  apiKeys: ApiCredentialModel[];
  readOnly: boolean;
  environmentId?: string;
  onUpdate: (credential: unknown) => unknown;
  onDelete: (credential: unknown) => unknown;
}

export default class TrackingKeysTableComponent extends Component<TrackingKeysTableComponentArgs> {
  keySortDefinition = ['isNew:desc'];
  @sort('args.apiKeys', 'keySortDefinition') sortedKeys!: ApiCredentialModel[];

  @computed('args.apiKeys.@each.environment')
  get credentialCountsByEnvironment() {
    return this.args.apiKeys.mapBy('environment.id').reduce(
      (acc: { [accountId: string]: number }, credEnvId: string): { [accountId: string]: number } => ({
        ...acc,
        [credEnvId]: acc[credEnvId] ? acc[credEnvId] + 1 : 1,
      }),
      {},
    );
  }
}
